import type { BookingListResponse } from '@/shared/api';
import type { StatusFilter } from '../components/bookingsListSearch';

export const STATUS_TABS: Array<[StatusFilter, string]> = [
  ['all', 'Alle'],
  ['Pending', 'Anfrage'],
  ['Confirmed', 'Bestätigt'],
  ['Cancelled', 'Storniert'],
];

const dayMonth = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'long',
  timeZone: 'UTC',
});

/** „Ab heute, 20. Oktober“ – oder „Alle Buchungen“, wenn auch Vergangene gezeigt werden. */
export function bookingsTitle(showPast: boolean, today: string): string {
  return showPast
    ? 'Alle Buchungen'
    : `Ab heute, ${dayMonth.format(new Date(`${today}T00:00:00Z`))}`;
}

/** Was die Liste zeigt, wie viele es sind und wie viele Preise noch geprüft werden. */
export function bookingsSubline(
  data: BookingListResponse,
  showPast: boolean,
  filtered: boolean,
): string {
  const count = `${data.total} ${data.total === 1 ? 'Buchung' : 'Buchungen'}`;
  const scope = showPast
    ? `${count}, auch vergangene`
    : `Wer im Haus ist, heute an- oder abreist und wer noch kommt · ${count}`;
  const review = data.priceUnderReviewCount;
  const prices =
    review > 0 ? ` · ${review} ${review === 1 ? 'Preis wird' : 'Preise werden'} geprüft` : '';
  return `${scope}${filtered ? ' – gefiltert' : ''}${prices}`;
}
